var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 29,
    viewBox: "0 0 72 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_24280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V29H187V0Z",
    fill: "url(#pattern0_205_24280)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_205_24280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 0H0V29H187V0Z",
    fill: "url(#pattern1_205_24280)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_205_24280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139 0H-48V29H139V0Z",
    fill: "url(#pattern2_205_24280)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_205_24280",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_205_24280",
    transform: "scale(0.00534759 0.0344828)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_205_24280",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_205_24280",
    transform: "scale(0.00534759 0.0344828)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_205_24280",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_205_24280",
    transform: "scale(0.00534759 0.0344828)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_24280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_205_24280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 29,
    fill: "white",
    transform: "translate(38)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_205_24280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 29,
    fill: "white",
    transform: "translate(54)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_205_24280",
    width: 187,
    height: 29,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALsAAAAdCAYAAADy1R2ZAAAKJ0lEQVR4Ae2cd8x1RRHGIVawIUgJKCICiqJisAKiiVgCBMWKAqKCBRULoEhQYowajKKIAVGIaLCgohAsiQqxixosKFY0KjZQLFhirD/3uZlZ5+7dPefc8vK+f5xNvuye3ZnZOfM+Z3dmdu+3ySaNAtwM+C/1ov5PAj8CPg2cC7wIuEND3Ng9WmDjWgC4ax3nk97rgM9Wxv8NvAO4zcZ9s1Gz0QKFBWylruB50nVFA+xO/+s0/rBC5Pg4WmDjWcBcmF84civ1W3rALha5Oq/ceG83ajRaIFgAeFcF4LHrUQPA7vRvCKLH5miBjWEBYFPgrY7SRv0H4OZzgF1ijlnFGwJbAA8HXgg8X64ScPtVyI4ygPsArwKe5f2KQ6xP/bfy/vWozQ4HAMcCLwWeBOy4Hrqsek7gyWbn/Vw2sJf1He19C9fAlgagHzYAHrtP1ERzgv3vCngXVRC4LXBeVKJor3T3AB4Y5D8O2Dp9VHLdVK5b9D2W5QNuB5wDyJ618glg92XnWU/+5EK/1l7s2wby3YGvWt85S+kGXNWRYiwN+hvglpoQeADwnASEM4EbSsLK86WLKgp8viKv7Dp1Ufk1Pnuvcg49H1ijX+s+y479uKZQ0fdn4BFrrc9aybeF7fvFO+nxGmDbpeatCG11/RPIW0ucFLgF8MYWY+jfP/INaQOHBX79sR/pfMDTwpiad/GxVdTAY5J78M70YWvFPB242yrkLiID+FZ411+au/l0QDvP64BvhHEB/k6LzLNReIDjgA8BH1GiYyXp7GCgvuaRfYYIW1BL1gV9Msrx5D9fFITNfGzA28P4YSW/P9uWKB9f//Zr+d02Lpr7Oq/XOjSrjdtq5LJVb+c8ZZ3ckB2CDNHeuqQpn5PbcmJ4R4F+i5JGz8B7A90lkcZ2BtdxJs5Jh4QPNr32jnwmd8dCZ5cT691KPuOVC/qQwH//Bt02gWYm/tBCE8bzhwzsHPq3KmUDD7LxfWSgvvIPBQ2lkNYzcHmHwL8quG3x1vojSBvjrw7zzegJHJ2C2d8FGm/K9ToqyhTwfBD4YhxTG/hwbdwMGoZ4d8nrz4UM8ezpY60a+GkQ3jy/SKv9VsBfAm0GTbHzzuywyU7aLVSuLfWwldWGm9XZkQ/YzOKLGoPclKnFBDg0EL68kKXERPwbnuDjya0+NfAd5P1eAz+z8ev7wK5c+/2ccUhtvnyYf6a51xA5Q2i0Oicj/SDMsEPkA04IY63moc7TBfYE/v0LAfljqIBdAeTM6ptOl7cvZOixE+yFPa9xXVs18J4wx/FOtyTYI6CC+KlmCfbLpkZnH+Rq5b9XD9jPKNhXCvZ/JR/pNGBzN9Y8tTIWhXLx8fB5ZJW0wAssDSX9fhUEnxJplYoLY/q6761x4B7AWWHscufrAXsZNHWBXeKPdblem95h6kmzD+xxxXufy2rVaWV+bpjgTKdbEuwRbM8IboNSn14y2IHneaf53FtKD+Chxc5/UtAvvmde2YE9gixvLg12nXh+DZBbsFT6Ku0GH3OtKvUMCPyFh9TFSi7xXwH2rfGan3eIjFyOB71u8LEW2IEXB3pv9oH9KpfrNaBrFGXpA7sCNS+nuaxWDTzeiQU0p1sS7Lro52WnIHNf70xxSga7xi19Kxcyr97Wf1DgOT/IaoH9M4HemwuDXWCRn/259MXqclf8t7MrM09t2QtXrKyPm0dWSVsBu+RrhX92SVs+h2Amrkg4XQ3saRdQ4KQtVyVmnFpg1y1QLznYs6yJ93/UGwPcmAj2N7uurTplbR4bZF/kdIXux4fV2YNM94lrPvv7g8zJKi25WmRC/xTYfV6vQ+x1QeC5OIzPgD2lxZ8QaJUN89IC+0mV97rWmCY+uz+4oFgf7MrMU6dTzi9EIUV7+VMwUwY4vAjInlnqCZycVnatDj8p9MiPztMAu69qcoW2y0whgC189rNT9sH91fOC7EuN94N2JdpF9a3sT3VCYIgbE12Is8L88UMNImeaNbBf4lQuT3UX2M2NVNpWi2jrHKYJdgtwlVtXkU2VZvXSAruP1+oJ2L9eG7G+18eXG9K2o2xlcFplJhMwRG6Lplgxr3Q6O230kzfXRcYT8HXEnv8AgWcqG6Pg3BltxVRWwEtrZdcf5ilGNAlUE0h3cyYLdP0DUncf2JU68zIkQI3px1aA6vJqdQ3sefFyW6lugd0+/j8Wwr+Z3vViOxPwoS6w61qGyp8s5bsSsOv+eatI4bmCVDtVbclT/zbRYF1tndaGbSm7BJHH3Iw8n48VOf+PlwdOKYD8vTMFnhLscvFULhONfcjW9f/UZLmyG63uEKkooH6Tta+2scFgN/qYepyJP0SjYqlHd7k0ZcxHx5V9XjfGd8Wpj60D7DqV96IDoYwhy+f7WAvsb3MCD/QHruy9bsyRQXCteYbZsrcC7h5XzIqwK3qFBAIDexQz80uowke93tmBvPWmdNwu3q/a7gJluT5WuDF5XBkc4xu0shut+5jfTb8N8FXuZTY2L9i1E3m5snbPyD7EC51Ih3H+XjZnBPvM7trKsxe2+lQhs+qzBx2+F+lNjyPCeAvsTvId5x8I9t48u5L/2iq6iraUTX3iWm03BT2B35L1khpvV59tfS7vy+lngPs4PaBMS1zJcpBUnCYe4jyqy2yRjzXAfnoYnwfs93SlQ721zT8X2I0nXgeQSAV6fl1AqcFoB7Xzqm78c4PdUoXnB/1PdluYzBbYdXioIlcxL1Dmzul+lZc+sOcDtJWA3ZR+jc/eUcvnenQJegvaTkmBoHLzXeVv8qOjsYa0zUDZ5eiYQCeAOc2V7oocXNB+yTJNCsilSw7MXY8K2H8bdZ7HjTG7xtPkfFVingA16LZrCsgXvgiW3m0RsEcT6gOackE73BgFpl60kCrD535/fIcusF/o7262HOKzd6/sJkgrVg7YXMtG/XNTXi8gAP2nQVd25wOE+BJD2umI/V7FRacoWy6Cbl7euZRlgWik9bbSc/lilfNVwD6VOVoA7Ef5hIo9wjxzr+zitaBbvHNf8V0S7FqpD3D9ve4A++Yp1RjTq24GJQj29gft2kFWTD2KZOrvubKV3Qx5TFBi1U1twTf1F1u0NuNqF5FbpRRbBlBLpgHkQOAV9rvaO9r7KtMyyTFHXu9ryQ7j+W5HcREsX4iy9FltjnipqfciWNTPdNflKv/xhq5EPLHvxxuLXASzC3PSv7ojm209T5/f2/VNv3jbydLD+nsphbqZ6e88ewTaeBFsctrtY8ajtK/zZRctnJ1orPsiWCGw6+Rz0Q9ABz7bx3nG9miBdbeAUkTFldpFAe58V6dAcdd1f7FRgdECLQvYqeNQX9yBXdYfWMmF+5aSY/9ogVVZwAIJ/Q5w3qIsxxGr0mOUM1rgRrGA/W8DCiwUWStd1yr6n8BEoxt3N7lRlBsnGS2wVhaw/zhJhwhKEen/dVSEraNg3QNZ7oewa6X0KHe0QLDA/wDNv2FLLZXcsAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.f1f648867b634c417eafdf45ee5de120.svg";
export { ForwardRef as ReactComponent };